export default __webpack_public_path__ + "img/987af9df9ed2e420fc4b6fd6aa457a76.png";